import { createAtlAttributionHeader } from '../../../../../common/fetch/atl-attribution-header';
import { fetchAggResponse } from '../../../../../common/fetch/fetch-agg-response';
import { logger } from '../../../../../common/utils/logger';
import {
	CONFLUENCE_PAGE_CONTRIBUTORS_OPERATION_NAME,
	KnowledgeDiscoveryConfluencePageContributorsQuery,
} from '../gql/confluence-contributors-query';
import type {
	ConfluencePageContributor,
	ConfluencePageContributorsResponse,
	ConfluencePageContributorsVariables,
	ConfluencePageContributorType,
} from '../gql/types';

export const getConfluencePageContributors = async ({
	id,
	workspaceId,
	cloudId,
	product,
}: {
	id: string;
	workspaceId: string;
	cloudId: string;
	product: string;
}): Promise<ConfluencePageContributor[] | null | undefined> => {
	try {
		const contributors: ConfluencePageContributor[] = [];
		const { data, errors } = await fetchAggResponse<
			ConfluencePageContributorsVariables,
			ConfluencePageContributorsResponse
		>({
			graphQuery: KnowledgeDiscoveryConfluencePageContributorsQuery,
			variables: { id },
			operationName: CONFLUENCE_PAGE_CONTRIBUTORS_OPERATION_NAME,
			headers: {
				...createAtlAttributionHeader({
					atlWorkspaceId: workspaceId,
					tenantId: cloudId,
					product,
				}),
				'X-Query-Context': workspaceId,
			},
		});
		if (errors) {
			logger.error({
				feature: 'knowledge-cards',
				element: 'container',
				operation: 'fetch-contributors',
				category: 'graphql',
				error: errors[0],
				functionName: 'getConfluenceContributors',
			});
			return null;
		}

		data?.contributorsLinkedToConfluencePageV2.queryResult.rows.forEach((row) => {
			row.rowItems.forEach((item, index) => {
				const type = row.rowItems[index].key;

				if (
					item.value &&
					item.value.length > 0 &&
					(type === 'creator' ||
						type === 'owner' ||
						type === 'editor' ||
						type === 'commentor' ||
						type === 'tagged')
				) {
					item.value.forEach((contributor) => {
						contributors.push({
							...contributor,
							type: type as ConfluencePageContributorType,
						});
					});
				}
			});
		});

		return contributors;
	} catch (error) {
		logger.error({
			feature: 'knowledge-cards',
			element: 'container',
			operation: 'fetch-contributors',
			category: 'unknown',
			error,
			functionName: 'getConfluenceContributors',
		});
		return null;
	}
};
